<div class="general-error">
  {{ props.errorMsg$ | async }}
</div>
